export function handleSwipeRight(step: number, setStep: (arg: number) => void) {
  if (step > 0) {
    setStep(step - 1);
  }
}

export function handleSwipeLeft(
  pages: number,
  step: number,
  setStep: (arg: number) => void,
) {
  if (step <= pages - 2) {
    setStep(step + 1);
  }
}
